import Vue from 'vue'
import { loadingText, messageDuration } from '@/config'
import { Loading, Message, MessageBox, Notification } from 'element-ui'
import * as lodash from 'lodash'
import dayjs from 'dayjs'
import store from '@/store'
import vue from '@/main'
import {
  getTextValue,
  getEnumText,
  weekMatching,
  formatTimeMsel,
  getEnumTextChange,
  formatNumber,
  moneyFormat,
  getFomateMonth,
  checkfileSize,
  checkEfile,
  formatDateTime,
  formatTimeDayLong,
  formatTimeDefault,
} from '@/utils/index'
import { compareArr } from '@/utils/compare'
let format = require('string-format')
import download from '@/utils/download'
import mixSearch from '@/utils/mixSearch'
import {
  checkEnumFlag,
  isEqualCodeEnum,
  getNotifyList,
  getFieldValue,
  downloadBlob,
} from '@/utils/validate'
import debounce from 'lodash/debounce'

const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
const minMax = require('dayjs/plugin/minMax')
const isBetween = require('dayjs/plugin/isBetween')
var customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(minMax)
dayjs.extend(isBetween)
//import { dependencies } from '../../../package.json'

// 全局方法挂载
Vue.prototype.getEnumText = getEnumText
Vue.prototype.getEnumTextChange = getEnumTextChange
Vue.prototype.getTextValue = getTextValue
Vue.prototype.checkEnumFlag = checkEnumFlag
Vue.prototype.isEqualCodeEnum = isEqualCodeEnum
Vue.prototype.getNotifyList = getNotifyList
Vue.prototype.getFieldValue = getFieldValue
Vue.prototype.downloadBlob = downloadBlob
Vue.prototype.downloadCommon = download
Vue.prototype.weekMatching = weekMatching
Vue.prototype.compareArr = compareArr
Vue.prototype.format = format
Vue.prototype.formatTimeMsel = formatTimeMsel
Vue.prototype.formatNumber = formatNumber
Vue.prototype.moneyFormat = moneyFormat
Vue.prototype.getFomateMonth = getFomateMonth
Vue.prototype.checkfileSize = checkfileSize
Vue.prototype.checkEfile = checkEfile
Vue.prototype.formatTimeDayLong = formatTimeDayLong
Vue.prototype.formatDateTime = formatDateTime
Vue.prototype.formatTimeDefault = formatTimeDefault

Vue.prototype.$baseColorfullLoading = (
  index = undefined,
  text = loadingText
) => {
  let loading
  if (!index) {
    loading = Loading.service({
      lock: true,
      text,
      spinner: 'dots-loader',
      background: 'hsla(0,0%,100%,.8)',
    })
  } else {
    const spinnerDict = {
      1: 'dots',
      2: 'gauge',
      3: 'inner-circles',
      4: 'plus',
    }
    loading = Loading.service({
      lock: true,
      text,
      spinner: spinnerDict[index] + '-loader',
      background: 'hsla(0,0%,100%,.8)',
    })
  }
  return loading
}
Vue.mixin(mixSearch)

/**
 * @description 全局加载层
 * @param {number} index 自定义加载图标类名ID
 * @param {string} text 显示在加载图标下方的加载文案
 */
Vue.prototype.$baseLoading = (index = undefined, text = loadingText) => {
  return Loading.service({
    lock: true,
    text,
    spinner: index ? 'vab-loading-type' + index : index,
    background: 'hsla(0,0%,100%,.8)',
  })
}

/**
 * @description 全局多彩加载层
 * @param {number} index 自定义加载图标类名ID
 * @param {string} text 显示在加载图标下方的加载文案
 */
Vue.prototype.$baseColorfullLoading = (
  index = undefined,
  text = loadingText
) => {
  let loading
  if (!index) {
    loading = Loading.service({
      lock: true,
      text,
      spinner: 'dots-loader',
      background: 'hsla(0,0%,100%,.8)',
    })
  } else {
    const spinnerDict = {
      1: 'dots',
      2: 'gauge',
      3: 'inner-circles',
      4: 'plus',
    }
    loading = Loading.service({
      lock: true,
      text,
      spinner: spinnerDict[index] + '-loader',
      background: 'hsla(0,0%,100%,.8)',
    })
  }
  return loading
}

/**
 * @description 全局Message
 * @param {string|VNode} message 消息文字
 * @param {'success'|'warning'|'info'|'error'} type 主题
 * @param {string} customClass 自定义类名
 * @param {boolean} dangerouslyUseHTMLString 是否将message属性作为HTML片段处理
 */
let messageDom = null
Vue.prototype.$baseMessage = (
  message,
  type = 'info',
  dangerouslyUseHTMLString = false
) => {
  if (messageDom) messageDom.close()
  messageDom = Message({
    message,
    type,
    customClass: 'change' + type,
    offset: 32,
    duration: messageDuration,
    dangerouslyUseHTMLString,
    showClose: true,
  })
}

/**
 * @description 全局Alert
 * @param {string|VNode} content 消息正文内容
 * @param {string} title 标题
 * @param {function} callback 若不使用Promise,可以使用此参数指定MessageBox关闭后的回调
 */
Vue.prototype.$baseAlert = (content, title = '確認', callback = undefined) => {
  MessageBox.alert(content, title, {
    confirmButtonText: '确定',
    dangerouslyUseHTMLString: true,
    callback: () => {
      if (callback) {
        callback()
      }
    },
  })
}

/**
 * @description 全局Confirm
 * @param {string|VNode} content 消息正文内容
 * @param {string} title 标题
 * @param {function} callback1 确认回调
 * @param {function} callback2 关闭或取消回调
 * @param {string} confirmButtonText 确定按钮的文本内容
 * @param {string} cancelButtonText 取消按钮的自定义类名
 */
Vue.prototype.$baseConfirm = (
  content,
  title = undefined,
  callback1 = undefined,
  callback2 = undefined,
  confirmButtonText = '確定',
  cancelButtonText = 'キャンセル'
) => {
  MessageBox.confirm(content, title || '確認', {
    confirmButtonText,
    cancelButtonText,
    closeOnClickModal: false,
    type: 'warning',
    lockScroll: false,
  })
    .then(() => {
      if (callback1) {
        callback1()
      }
    })
    .catch(() => {
      if (callback2) {
        callback2()
      }
    })
}

/**
 * @description 全局Notification
 * @param {string} message 说明文字
 * @param {string|VNode} title 标题
 * @param {'success'|'warning'|'info'|'error'} type 主题样式,如果不在可选值内将被忽略
 * @param {'top-right'|'top-left'|'bottom-right'|'bottom-left'} position 自定义弹出位置
 * @param duration 显示时间,毫秒
 */
Vue.prototype.$baseNotify = (
  message,
  title,
  type = 'success',
  position = 'top-right',
  duration = messageDuration
) => {
  Notification({
    title,
    message,
    type,
    duration,
    position,
  })
}

Vue.prototype.msgSuccess = function (msg) {
  this.$baseMessage(msg, 'success')
}
Vue.prototype.msgError = function (msg) {
  this.$baseMessage(msg, 'error')
}
Vue.prototype.msgInfo = function (msg) {
  this.$baseMessage(msg, 'warning')
}

/**
 * @description 表格高度
 * @param {*} formType
 */
/* 全局TableHeight */
Vue.prototype.$baseTableHeight = (diff = 40) => {
  let height = window.innerHeight
  //header + tabs
  let headHeight = 185
  //pager
  let formHeight = 95

  //queryBar
  let queryBar = document.getElementsByClassName('vab-query-form')
  if (queryBar.length > 0) {
    formHeight = queryBar[0].clientHeight
  }

  //toolbar
  let toolBar = document.getElementsByClassName('vab-box-area')
  let toolBarHeight = 0
  if (toolBar.length > 0) {
    toolBarHeight = toolBar[0].clientHeight
  }

  height = height - headHeight - formHeight - toolBarHeight - diff
  return height
}

/* 全局lodash */
Vue.prototype.$baseLodash = lodash
/* 全局dayjs */
Vue.prototype.$dayjs = dayjs
/* 全局事件总线 */

Vue.prototype.$closePage = async (path) => {
  await store.dispatch('tabs/delVisitedRoute', path).then(() => {})
}
/**ルートリロード */
Vue.prototype.$routerPushAndReload = async (params) => {
  //await store.dispatch('tabs/delVisitedRoute', params.path).then(() => {})
  let routes = await store.getters['tabs/visitedRoutes']
  const target = routes.find(
    (item) =>
      item.name.toUpperCase() === params.name?.toUpperCase() ||
      item.path.toUpperCase() === params.path?.toUpperCase()
  )
  await store.dispatch('notify/setRefresh', params.refresh).then(() => {})
  if (params?.path || params?.name) {
    vue.$router.push(target ? target : params)
  }
}

/**路由修改 */

/**
 * @description 全局事件总线
 */
Vue.prototype.$baseEventBus = new Vue()

Vue.prototype.$const = require('@/config/const.config')
//区分
Vue.prototype.$divisions = require('@/biz/divisions/model/index')

//エラー
Vue.prototype.$messageCode =
  require('@/biz/divisions/messageCode').messageCodeEnum

/**路由修改 */
Vue.prototype.$routerPush = debounce(async (params, override = false) => {
  let routes = await store.getters['tabs/visitedRoutes']
  const target = routes.find(
    (item) =>
      item.name.toUpperCase() === params.name?.toUpperCase() ||
      item.path.toUpperCase() === params.path?.toUpperCase()
  )
  if (target) {
    if (override) {
      await store.dispatch('tabs/delVisitedRoute', target.path)
      vue.$router.push(params)
      return true
    }
    vue.$confirm({
      msg: '既に開かれているページがあります、引き続きこのページへ遷移してよろしいでしょうか？遷移する場合、前回開いていたページが閉じられます。',
      yesText: '確定',
      yes: async () => {
        await store.dispatch('tabs/delVisitedRoute', target.path)
        await store.dispatch('notify/setWorkList', [])
        vue.$router.push(params)
        return true
      },
      no: () => {
        return false
      },
    })
  } else {
    vue.$router.push(params)
    return true
  }
}, 200)
